import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service7Second = () => {
    return (
        <div className="about-events-main-container"> {/* Main outer container */}
            <div className="about-events-container2">
                <div className="about-events-wrapper"> {/* Flexbox container */}
                    <div className="about-events-content2">
                        <h2 className="about-header-service2">Awrudu Celebration Package Details</h2>
                        <p className="about-events-description2">
                            Celebrate your <strong>Awrudu Celebrations</strong> with us! Whether you're planning a joyful gathering with your family, a fun-filled celebration with colleagues, or a memorable day with friends, Cocoloco Garden is the perfect place to embrace the spirit of the New Year.
                        </p>

                        <ul className="about-events-list2">
                            <h2 className="about-subheader-service2">Exclusive Package Includes:</h2>
                            <li>- Minimum Pax: <strong>15 persons (weekday) and 25 persons (weekend)</strong> (subject to variations based on availability and arrangements)</li>
                            <li>- Complimentary <strong>Welcome Drink</strong> for all guests</li>
                            <li>- <strong>Compulsory Room</strong> for your comfort and privacy</li>
                            <li>- Access to the <strong>Swimming Pool</strong> for a refreshing experience</li>
                            <li>- Delicious <strong>Lunch Buffet</strong> with a variety of dishes</li>
                            <li>- <strong>Evening Tea and Snack</strong></li>
                            <li>- Time: <strong>9 AM to 5 PM</strong></li>
                            <li>- Exciting <strong>Awrudu Games</strong></li>
                            <li>- For groups of 50 or more, enjoy a <strong>free DJ</strong> to keep the energy high!</li>
                            <li>- Get <strong>20% Off</strong> on Breakfast and Dinner Menu</li>
                            <li>- This Package is valid only from March to May 2025</li>
                        </ul>
                    </div>

                    <div className="about-events-grid2">
                        <div className="about-events-images2">
                            <img
                                src={`${process.env.PUBLIC_URL}/package/packawrudu.webp`}
                                className="service2-images3"
                                alt="Pack Awrudu"
                            />

                            <img
                                src={`${process.env.PUBLIC_URL}/package/packawrudu1.webp`}
                                className="service2-images3"
                                alt="Second Package"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Service7Second;
